
const styles = () => ({
  assetCard: {
    borderTop: '1px solid #D9DCDF',
    '&:last-child': {
      borderBottom: '1px solid #D9DCDF',
    },
    paddingTop: 12,
    paddingBottom: 12,
  }
});

export default styles;